// Added by Sejune Oh on 2019-02-19
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { makeAutoObservable } from 'mobx'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Define
import { SNACK_BAR_EVT, SNACK_BAR_HORI_OPTION, SNACK_BAR_VERT_OPTION } from '../helper/define'

// Root Store
import Rootstore from './index'

// Style
import { SNACK_BAR_VALID_TIME } from '../styles/Theme'
import { createRef } from 'react'
import { DialogContentProps } from '../components/common/Dialog'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Show event methods parameter
export interface ShowEventParam {
    message: string
    evtType: SNACK_BAR_EVT
    evtValidTime?: number
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export default class EventStore {
    root?: Rootstore
    dialogRef = createRef<any>()

    isOnLoading: boolean = false
    isEvtOccured: boolean = false
    isAutoClosable: boolean = true
    message: string = ''
    evtType: SNACK_BAR_EVT = 'error'
    evtValidTime: number = SNACK_BAR_VALID_TIME
    vertical: SNACK_BAR_VERT_OPTION = 'bottom'
    horizontal: SNACK_BAR_HORI_OPTION = 'right'
    handleDialogConfirm?: () => Promise<{}>
    handleDialogCancel?: () => Promise<{}>
    isScreenLockActive: boolean = false
    isConfigLoaded: boolean = false
    showNotifications: boolean = false

    constructor(root: Rootstore) {
        this.root = root
        this.finishEvent = this.finishEvent.bind(this)
        makeAutoObservable(this)
    }

    showEvent({ message, evtType, evtValidTime = SNACK_BAR_VALID_TIME }: ShowEventParam) {
        this.message = message
        this.evtType = evtType
        this.evtValidTime = evtValidTime

        this.isEvtOccured = true
    }

    _emptryPromise = (): Promise<{}> => {
        return new Promise((resolve) => resolve(true))
    }

    finishEvent() {
        this.isEvtOccured = false
    }

    setLoadingOn() {
        this.isOnLoading = true
    }

    setLoadingOff() {
        const loadingWrapper = document.getElementById('loading-wrapper') as HTMLSpanElement

        if (loadingWrapper) loadingWrapper.style.opacity = '0'

        setTimeout(() => {
            this.isOnLoading = false
            if (loadingWrapper) loadingWrapper.style.opacity = '1'
        }, 400)
    }

    openDialog(dialogInfo: DialogContentProps, confirmTask = this._emptryPromise, cancelTask = this._emptryPromise) {
        this.handleDialogConfirm = confirmTask
        this.handleDialogCancel = cancelTask
        this.dialogRef!.current.setDialogInfo(dialogInfo).handleOpen()
    }

    setScreenLockFlag = (flag: boolean) => {
        this.isScreenLockActive = flag
    }

    setConfigLoadingFlag = (flag: boolean) => {
        this.isConfigLoaded = flag
    }

    setShowNotifications = (flag: boolean) => {
        this.showNotifications = flag
    }
}
